import PropTypes from 'prop-types';

/*
NutritionInfo is the component that display nutrition usually
html formatted of a Recipe/Pairing card
props:
nutritionHTML: NutritionInfo in text or Html format.
*/
const NutritionInfo = ({ nutritionHTML }) => {
  if (!nutritionHTML) {
    return <></>;
  }

  return (
    <div data-testid="nutrition-info">
      <span className="hr-paragraph-bold">Nutrition</span>
      <div
        className="product-details-text"
        dangerouslySetInnerHTML={{ __html: nutritionHTML }}
      ></div>
    </div>
  );
};

NutritionInfo.propTypes = {
  nutritionHTML: PropTypes.string,
};

export default NutritionInfo;
